<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">地图设置</div>
      <el-form-item label="高德key">
        <el-input v-model="amap" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="腾讯key">
        <el-input v-model="map_qq" class="max-w460"></el-input>
      </el-form-item>
     
      
      <!-- <el-form-item label="状态">
        <el-radio-group v-model="form.is_open">
          <el-radio label="0">关闭</el-radio>
          <el-radio label="1">开启</el-radio>
        </el-radio-group>
        <div style="color:#ff6f06">注：如开启则显示隐私号码拨打，关闭则不显示</div>
      </el-form-item> -->
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

  </div>

</template>

<script>
import SettingApi from "@/api/setting.js";

export default {
  data() {
    return {
      /*form表单数据*/
      amap:'',
      map_qq:'',
      loading: false
    };
  },
  created() {
    this.getData();
  },

  methods: {
    getData() {
      let self = this;
      SettingApi.getmap({}, true)
        .then(data => {
          self.amap=data.data.vars.values.amap
          self.map_qq=data.data.vars.values.map_qq
          console.log(data)
          // let vars = data.data.vars.values;
          // self.form = data.data.vars.values;
        })
        .catch(error => {});
    },
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      SettingApi.postmap({
        amap:self.amap,
        map_qq:self.map_qq
      }, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，设置成功",
            type: "success"
          });
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/acsign/index.vue